import { Component, input } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-mobile-table-card',
    templateUrl: './mobile-table-card.component.html',
    imports: [RouterModule]
})
export class MobileTableCardComponent {
    public accentColor = input.required<string>();
}
